import { useEffect, useState } from 'react'

// Reactive `window.matchMedia` wrapper. Re-renders when the given media query starts/stops matching.
export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    mql.addEventListener('change', onChange)
    // Sync once in case the viewport changed between the initial render and this effect.
    setMatches(mql.matches)

    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}

// Matches the Tailwind `xl` breakpoint (1280px) used across the layout (e.g. `max-xl:hidden` on the
// desktop sidebar, `xl:hidden` on the mobile drawer).
export const useIsDesktop = () => useMediaQuery('(min-width: 1280px)')
